<template>
    <div>
        <div class="modal modal-full-screen modal-fx-fadeInScale" v-bind:class="{ 'is-active': showModal }">
            <div class="modal-background" @click="close"></div>
            <div class="modal-card is-fullwidth" :class="[theme, fullscreen ? 'fullscreen' : '']">
                <header class="modal-card-head">
                    <p class="modal-card-title">{{ title }}</p>
                    <button class="delete" aria-label="hasSeenNotice" @click="close"></button>
                </header>

                <section class="modal-card-body">
                    <slot>Loading content...</slot>
                </section>
                <footer class="modal-card-foot">
                    <button class="button" @click="close">Done</button>
                </footer>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase/app';
import { db } from '../main.js';
import NProgress from 'nprogress';

export default {
    props: {
        theme: String,
        title: String,
        details: String,
        fullscreen: Boolean
    },

    data: function () {
        return {
            showModal: true
        };
    },

    methods: {
        close: function () {
            this.showModal = false;
            let result = {
                answer: 'Modal closed',
                modal: false
            };
            this.$emit('closed', result);
        }
    }
};
</script>

<style lang="scss" scoped>
.modal-card-title {
    color: #fff;
    font-size: 1.1rem;
    flex-shrink: initial;
    text-align: left;
}
.modal-close,
.delete {
    max-height: none;
    max-width: none;
    width: 30px;
    height: 30px;
    text-align: center;
}
.modal-card-body {
    text-align: left;
    color: #333;
    min-height: 0;
}
.modal-card {
    width: 90%;
    max-width: 600px;
    overflow: visible;
    max-height: 75%;
    margin-top: 20px;
    &.red {
        .modal-card-head {
            background: #dd7979;
        }
        .modal-card-foot {
            background: #ededed;
            .button {
                background: #dd7979;
                border-color: #dd7979;
                color: #fff;
            }
        }
    }
    &.green {
        .modal-card-head {
            background: #67bf8e;
        }
        .modal-card-foot {
            background: #ededed;
            .button {
                background: #67bf8e;
                border-color: #67bf8e;
                color: #fff;
            }
        }
    }
    &.blue {
        .modal-card-head {
            background: #0cabe1;
        }
        .modal-card-foot {
            background: #ededed;
            .button {
                background: #0cabe1;
                border-color: #0cabe1;
                color: #fff;
            }
        }
    }
    &.orange {
        .modal-card-head {
            background: #ffbb3e;
        }
        .modal-card-foot {
            background: #ededed;
            .button {
                background: #ffbb3e;
                border-color: #ffbb3e;
                color: #fff;
            }
        }
    }
    &.extreme {
        .modal-card-head {
            background: #ee4646;
        }
        .modal-card-foot {
            background: #ededed;
            .button {
                background: #ee4646;
                border-color: #ee4646;
                color: #fff;
            }
        }
    }
    &.high {
        .modal-card-head {
            background: #ff7600;
        }
        .modal-card-foot {
            background: #ededed;
            .button {
                background: #ff7600;
                border-color: #ff7600;
                color: #fff;
            }
        }
    }
    &.medium {
        .modal-card-head {
            background: #ffbb3e;
        }
        .modal-card-foot {
            background: #ededed;
            .button {
                background: #ffbb3e;
                border-color: #ffbb3e;
                color: #fff;
            }
        }
    }
    &.low {
        .modal-card-head {
            background: #67bf8e;
        }
        .modal-card-foot {
            background: #ededed;
            .button {
                background: #67bf8e;
                border-color: #67bf8e;
                color: #fff;
            }
        }
    }
    &.fullscreen {
        max-width: 1200px;
    }
}

.risk-pair {
    border-bottom: 1px solid #e4e4e4;
    padding-bottom: 10px;
    margin-bottom: 10px;
    .risk-pair-item {
        .risk-pair-title {
            font-size: 0.8rem;
            color: red;
            text-transform: uppercase;
            &.control {
                color: mediumseagreen;
                margin-top: 8px;
            }
        }
        .risk-pair-details {
            font-size: 0.9rem;
        }
    }
    &:last-of-type {
        border: none;
    }
}

// Only leaving this in here for the pdf stuff, images have now gone to image-wrap2
ul.uploads {
    list-style: none;
    height: auto;
    margin-bottom: 2rem;

    li {
        display: inline-flex;
        max-width: 200px;
        min-width: 100px;
        margin: 0 1rem 1rem 0;
        height: 100%;
        float: left;
        // padding: 15px;
        border: 1px solid #ddd;
        position: relative;
        cursor: pointer;

        img {
            width: 100%;
            align-self: center;
        }

        &.show {
            width: 100%;
            max-width: none;
            display: inline-table;

            img {
                max-width: none;
            }
        }

        .caption {
            border: none;
            position: absolute;
            bottom: 0;
            left: 0;
            font-size: 0.9rem;
            width: 100%;
            padding: 8px;
            background: #f4f4f4;
            text-align: center;
            border: none;
            border-radius: 0;

            input {
                border: none;
                background: none;
                padding: 0;
                height: auto;
                min-height: 0;
                margin: 0;
                border-radius: 0;
                font-size: 0.9rem;
                line-height: 1rem;
                text-align: center;
            }

            textarea {
                min-height: 0;
                border: none;
                background: none;
                padding: 0;
                height: auto;
                min-height: 0;
                margin: 0;
                border-radius: 0;
                font-size: 0.9rem;
                line-height: 1rem;
                text-align: center;
            }
        }

        .cross {
            justify-content: center;
            position: absolute;
            top: -12px;
            right: -12px;
            z-index: 999;
            background: #dedede;
            padding: 10px;
            width: 35px;
            height: 35px;
            display: flex;
            border-radius: 50%;
            transition: 0.2s;
            cursor: pointer;

            &:hover {
                color: red;
            }
        }
    }
}
</style>
